import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f0d8da5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "landingpage-background w-screen h-screen" }
const _hoisted_2 = {
  class: "flex flex-col",
  style: {"height":"1020px"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-lg md:text-lg" }, "Bauwerke", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid grid-cols-8 justify-items-stretch items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, " Frage "),
  /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold col-span-3 border-solid rounded-md whiteYellowBorderColor" }, " Beschreibung/Eingabewerte "),
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, " Weitere Eingaben "),
  /*#__PURE__*/_createElementVNode("div", { class: "col-span- text-sm font-bold border-solid rounded-md whiteYellowBorderColor" }, " Bewertung ")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs col-span-2 ml-2 mt-2" }, "Bauwerke:", -1))
const _hoisted_7 = { class: "text-xs col-span-3 text-gray-500" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs md:text-xs" }, "Tragfähig:", -1))
const _hoisted_9 = { class: "text-xs text-gray-500" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-span-2" }, null, -1))
const _hoisted_11 = { class: "text-xs col-span-3 text-gray-500" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "justify-center items-center col-span-8",
  style: {"background-color":"rgb(235, 239, 240)","border-style":"solid","border-color":"rgb(235, 239, 240) rgb(235, 239, 240)\n                    rgb(235, 239, 240) rgb(235, 239, 240)","border-radius":"5px"}
}, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-center" }, " Keine Bauwerke aufgenommen ")
], -1))
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tng_header = _resolveComponent("tng-header")!
  const _component_PdfChip = _resolveComponent("PdfChip")!
  const _component_oneto_five_image_div = _resolveComponent("oneto-five-image-div")!
  const _component_pdf_a4_page = _resolveComponent("pdf-a4-page")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getBauwerkePages(_ctx.ba), (bauwerkePage, key) => {
    return (_openBlock(), _createBlock(_component_pdf_a4_page, {
      "no-margin": "",
      "pdf-key": _ctx.lang,
      class: "pdf-content",
      key: key
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_tng_header, {
              ba: _ctx.ba,
              immobilie: _ctx.immobilie,
              lang: _ctx.lang
            }, null, 8, ["ba", "immobilie", "lang"]),
            _hoisted_3,
            (_ctx.getBauwerkePages(_ctx.ba) > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _hoisted_5,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bauwerkePage, (bauwerk, key) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: key,
                      class: "ml-2 mt-2 grid grid-cols-8 justify-items-stretch items-center",
                      style: {"border-style":"solid","border-color":"var(--white100) var(--white100) var(--white100) rgb(216, 215, 26)","border-radius":"5px"}
                    }, [
                      _hoisted_6,
                      _createElementVNode("div", _hoisted_7, _toDisplayString(bauwerk['freitext']), 1),
                      _hoisted_8,
                      _createElementVNode("div", _hoisted_9, _toDisplayString(bauwerk['tragfaehig']), 1),
                      _createVNode(_component_PdfChip, {
                        color: "green",
                        "mangel-amount-mode": "",
                        value: bauwerk['bauwerk-bewertung'],
                        "pdf-mode": "",
                        class: "justify-self-end"
                      }, null, 8, ["value"]),
                      _hoisted_10,
                      _createElementVNode("div", _hoisted_11, _toDisplayString(bauwerk['beschreibung']), 1),
                      _createVNode(_component_oneto_five_image_div, {
                        ba: null,
                        immobilie: null,
                        fragesPath: "null",
                        lang: _ctx.lang,
                        imageObjects: bauwerk['bild'],
                        class: "ml-2 col-span-8"
                      }, null, 8, ["lang", "imageObjects"])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
          ])
        ])
      ]),
      _: 2
    }, 1032, ["pdf-key"]))
  }), 128))
}